import { Amplify } from 'aws-amplify'
import { env } from '../utils/env'

const cognitoConfig = {
  userPoolId: env.VITE_COGNITO_USER_POOL_ID,
  userPoolClientId: env.VITE_COGNITO_USER_POOL_CLIENT_ID,
  identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID || '',
  region: env.VITE_COGNITO_REGION,
  domain: env.VITE_COGNITO_DOMAIN,
}

// Only configure Amplify if not in test mode
// In test mode, we bypass authentication entirely
const isTestMode = env.VITE_TEST === 'TRUE'

if (!isTestMode) {
  // Configure Amplify
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cognitoConfig.userPoolId,
        userPoolClientId: cognitoConfig.userPoolClientId,
        identityPoolId: cognitoConfig.identityPoolId || '',
        loginWith: {
          oauth: {
            domain: cognitoConfig.domain,
            scopes: ['phone', 'email', 'openid'],
            redirectSignIn: [env.VITE_COGNITO_SIGN_IN_URL],
            redirectSignOut: [env.VITE_COGNITO_SIGN_OUT_URL],
            responseType: 'code',
          },
        },
      },
    },
  })
} else {
  // Skip configuration in test mode
}

export const amplifyConfig = {
  cognito: cognitoConfig,
  apiUrl: env.VITE_API_URL,
  accessControlApiUrl: env.VITE_ACCESS_CONTROL_API_URL,
  environment: env.VITE_ENVIRONMENT,
}
